import React from 'react';
import ReactDOM from 'react-dom';
import { Chatbot } from 'redpoints-front-chatbot-rp10/Chatbot';

import { App } from 'redpoints-front-common-rp10/appLoader';
import type { AppProps } from 'redpoints-front-common-rp10/appLoader/App';
import { withLogin } from 'redpoints-front-common-rp10/authentication';
import type { AppConfig } from 'redpoints-front-common-rp10/types';

import {
  APPLICATION_NAME,
  APPLICATION_SUITE,
  APPLICATION_TOKEN,
  DEFAULT_PAGE_PATH_ON_TENANT_CHANGE,
  ENVIRONMENT,
  PAGE_PATHS_TO_REDIRECT_ON_TENANT_CHANGE,
  ROUTE_PATHS,
  ROUTES,
  SCHEME,
  VERSION,
} from './config/constants';
import menuConfig from './config/menuConfig';
import routes from './routes';
import configureStore from './store';

const { store } = configureStore();

const appConfig: AppConfig = Object.freeze({
  APPLICATION_NAME,
  APPLICATION_SUITE,
  APPLICATION_TOKEN,
  DEFAULT_PAGE_PATH_ON_TENANT_CHANGE,
  ENVIRONMENT,
  PAGE_PATHS_TO_REDIRECT_ON_TENANT_CHANGE,
  ROUTE_PATHS,
  ROUTES,
  SCHEME,
  VERSION,
});

const AppWithLogin = withLogin({
  App: props => (
    <App
      {...(props as Pick<AppProps, 'user'>)}
      appConfig={appConfig}
      menuConfig={menuConfig}
      routes={routes}
      store={store}
    >
      <Chatbot />
    </App>
  ),
  appData: {
    applicationToken: APPLICATION_TOKEN,
    suite: APPLICATION_SUITE,
    environment: ENVIRONMENT,
    scheme: SCHEME,
  },
});

ReactDOM.render(<AppWithLogin />, document.getElementById('root'));
